import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Classificacao de Materiais',
  path: '/merenda/merclassificacao',
  name: 'merclassificacao',
  component: () => import('@/views/merenda/merclassificacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.CLASSIFICACAODEMATERIAISNOVO_MENU_1900500199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Classificacao de Materiais',
  path: '/merenda/merclassificacao/cadastro/:id?',
  parent: 'merclassificacao',
  name: 'merclassificacao_create',
  component: () => import('@/views/merenda/merclassificacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.CLASSIFICACAODEMATERIAISNOVO_MENU_1900500199],
  },
  goesToMenu: true,
 },
]
